<template lang="pug">
.login
  .dialog: .dialog-inner
    .logo
      img.logo-img(src='/dist/logo.svg')
      branch-label
      .name {{$config.system_name}}

    .ui.piled.segment.form
      .ui.negative.message.visible(v-if='showMessage')
        i.close.icon(@click='dismiss')
        .header {{messageHeader}}
        p {{message}}

      .ui.warning.message.visible(v-if='timeout', @click='timeout = false')
        .header 已登出
        p 长时间未操作，请重新登陆。

      .ui.negative.message.visible(v-if='!server_available', @click='check_state()')
        .header 数据库未连接
        p 点击重新连接，若多次尝试无效，请联系相关人员处理。


      template(v-if='server_available')
        .ui.field
          input(v-model='username', placeholder='用户名')
        .ui.field
          input(v-model='password', type='password', placeholder='密码', @keydown.enter='login')
        .ui.field
          .ui.button.themed(@click='login') 登陆

    .version(v-if='$native.supported')
      i.icon.checkmark
      | 支持青柠檬宿本地调用插件
    .version {{version}}
</template>

<script>
import HttpStatus from 'http-status'
import version from '../../../version'
import idleChecker from '../idle'
import { BranchLabel } from '../components/basic'
import _ from 'lodash'

export default {
  name: 'login',
  components: { BranchLabel },
  data() {
    return {
      showMessage: false,
      messageHeader: '',
      message: '',
      username: '',
      password: '',
      version: `v${version}`,
      server_available: false,
      timeout: false,
      redirect: null,
    }
  },
  mounted() {
    this.check_state()
    this.$store.commit('CLEAR_BILLS')
    this.timeout = !!this.$route.query.timeout !== undefined
    this.redirect = this.$route.query.redirect
  },
  methods: {
    dismiss() {
      this.showMessage = false
    },
    show(header, message) {
      this.showMessage = true
      this.messageHeader = header
      this.message = message
    },
    check_state() {
      this.$http.get('system/state/database')
        .then(() => {
          this.server_available = true
        })
        .catch(() => {
          this.server_available = false
        })
    },
    login() {
      this.$http.post('users/login', { username: this.username, password: this.password })
        .then(r => {
          const body = r.body
          if (!body)
            this.show('请求失败', '请确认网络连接')
          else if (body.error)
            this.show('登陆失败', body.error.code)
          else {
            this.$user.username = body.data.user.username
            this.$user.display = body.data.user.display
            this.$user.permissions = body.data.user.permissions
            this.$user.roles = body.data.user.roles
            this.$user.save()
            idleChecker(this)
            if (this.redirect)
              this.$router.replace(this.redirect)
            else
              this.$router.$go.index()
          }
        })
        .catch(err => {
          if (err.status === HttpStatus.UNAUTHORIZED)
            this.show('登陆失败', '用户名或密码不正确')
          else
            this.show('请求失败', '请确认网络连接')
        })
    },
  },
}
</script>



// WEBPACK FOOTER //
// Login.vue?79639386